import React from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import RefreshIcon from '@material-ui/icons/Refresh';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import {
  MobileDesignConfigClasses,
  MobileDesignConfigState
} from '../MobileDesignConfig.types';
import { Input } from '../..';
import {
  TITLE_DESCRIPTION,
  CLIENT_SPACE,
  NEW_PRODUCTS_DESCRIPTION,
  LOYALTY_NAME
} from '../../../constants';

interface TextSectionProps {
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  onFieldChange: (
    field: 'titleDescription' | 'name' | 'newProductsDescription' | 'clientSpace',
    value: string
  ) => void;
  onReset: (
    field: 'titleDescription' | 'name' | 'newProductsDescription' | 'clientSpace',
    value: string
  ) => void;
}

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))(Tooltip);

export const TextSection: React.FC<TextSectionProps> = ({ classes, state, onFieldChange, onReset }) => {
  const { titleDescription, name, newProductsDescription, clientSpace } = state;

  return (
    <div>
      <p className={classes.designText}>Titre d'accueil</p>

      <Input
        margin="dense"
        id="titleDescription"
        type="text"
        variant="outlined"
        value={titleDescription}
        onChange={e => onFieldChange('titleDescription', e.target.value)}
        className={classes.inputStyle}
        multiline
        InputProps={{
          classes: {
            input: classes.resize
          },
          endAdornment:
            titleDescription !== TITLE_DESCRIPTION && (
              <InputAdornment position="end">
                <LightTooltip title="Remettre la valeur par défaut">
                  <RefreshIcon
                    className={classes.iconColor}
                    onClick={() => onReset('titleDescription', TITLE_DESCRIPTION)}
                  />
                </LightTooltip>
              </InputAdornment>
            )
        }}
        placeholder="Ex:Bienvenue chez..."
      />
      <p className={classes.designText}>Titre fidélité</p>

      <Input
        margin="dense"
        id="name"
        type="text"
        variant="outlined"
        value={name}
        onChange={e => onFieldChange('name', e.target.value)}
        className={classes.inputStyle}
        placeholder="Ex:Ma fidélité..."
        InputProps={{
          classes: {
            input: classes.resize
          },
          endAdornment:
            name !== LOYALTY_NAME && (
              <InputAdornment position="end">
                <LightTooltip title="Remettre la valeur par défaut">
                  <RefreshIcon className={classes.iconColor} onClick={() => onReset('name', LOYALTY_NAME)} />
                </LightTooltip>
              </InputAdornment>
            )
        }}
        multiline
      />
      <p className={classes.designText}>Titre produits en avant</p>

      <Input
        margin="dense"
        id="newProductsDescription"
        type="text"
        variant="outlined"
        value={newProductsDescription}
        onChange={e => onFieldChange('newProductsDescription', e.target.value)}
        className={classes.inputStyle}
        placeholder="Ex:Nos derniéres nouveautés..."
        InputProps={{
          classes: {
            input: classes.resize
          },
          endAdornment:
            newProductsDescription !== NEW_PRODUCTS_DESCRIPTION && (
              <InputAdornment position="end">
                <LightTooltip title="Remettre la valeur par défaut">
                  <RefreshIcon
                    className={classes.iconColor}
                    onClick={() => onReset('newProductsDescription', NEW_PRODUCTS_DESCRIPTION)}
                  />
                </LightTooltip>
              </InputAdornment>
            )
        }}
        multiline
      />
      <p className={classes.designText}>Espace client</p>

      <Input
        margin="dense"
        id="clientSpace"
        type="text"
        variant="outlined"
        value={clientSpace}
        onChange={e => onFieldChange('clientSpace', e.target.value)}
        className={classes.inputStyle}
        placeholder="Ex:Mon espace client"
        InputProps={{
          classes: {
            input: classes.resize
          },
          endAdornment:
            clientSpace !== CLIENT_SPACE && (
              <InputAdornment position="end">
                <LightTooltip title="Remettre la valeur par défaut">
                  <RefreshIcon
                    className={classes.iconColor}
                    onClick={() => onReset('clientSpace', CLIENT_SPACE)}
                  />
                </LightTooltip>
              </InputAdornment>
            )
        }}
        multiline
      />
    </div>
  );
};

